import store from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setIsSaving', function setIsValidatingDomain(newValue: boolean) {
    store.domainState.isValidatingDomain = newValue;
});
